import type { Language } from "@contracts/index";

/** Portal chrome texts (not the quote document, which uses the shared labels). */
const TEXT = {
  es: {
    title: "Consulta tus cotizaciones",
    intro: "Escribe el correo al que te enviamos la cotización y te mandaremos un enlace de acceso.",
    emailPlaceholder: "tu@empresa.com",
    send: "Enviar enlace",
    sending: "Enviando…",
    sent: "Si tu correo tiene cotizaciones, recibirás un enlace en unos minutos. Revisa también tu carpeta de spam.",
    tooMany: "Demasiados intentos. Espera un momento e inténtalo de nuevo.",
    genericError: "Algo salió mal. Inténtalo de nuevo.",
    verifying: "Verificando tu enlace…",
    invalidLink: "Este enlace ya no es válido o ya fue usado. Pide uno nuevo con tu correo.",
    requestNew: "Pedir un enlace nuevo",
    myQuotes: "Mis cotizaciones",
    none: "No tienes cotizaciones disponibles.",
    signOut: "Salir",
    back: "← Mis cotizaciones",
    loading: "Cargando…",
    other: "English",
  },
  en: {
    title: "View your quotes",
    intro: "Enter the email address we sent the quote to and we will email you an access link.",
    emailPlaceholder: "you@company.com",
    send: "Send link",
    sending: "Sending…",
    sent: "If your email has quotes, you will receive a link in a few minutes. Please also check your spam folder.",
    tooMany: "Too many attempts. Please wait a moment and try again.",
    genericError: "Something went wrong. Please try again.",
    verifying: "Checking your link…",
    invalidLink: "This link is no longer valid or was already used. Request a new one with your email.",
    requestNew: "Request a new link",
    myQuotes: "My quotes",
    none: "You have no quotes available.",
    signOut: "Sign out",
    back: "← My quotes",
    loading: "Loading…",
    other: "Español",
  },
} as const;

export type PortalText = (typeof TEXT)[Language];

export function portalText(language: Language): PortalText {
  return TEXT[language];
}

export function browserLanguage(): Language {
  const stored = safeGet("ctb_lang");
  if (stored === "es" || stored === "en") return stored;
  return navigator.language?.toLowerCase().startsWith("en") ? "en" : "es";
}

export function rememberLanguage(language: Language): void {
  try {
    localStorage.setItem("ctb_lang", language);
  } catch {
    // storage unavailable: preference lasts for this page only
  }
}

function safeGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}
